export default "__VITE_ASSET__g_Rjm9et__"